module.exports = __webpack_public_path__ + "static/media/welcome.da13db44.png";